import { Reveal } from "@/components/Reveal";
import { PRICING_LEAD, TIER_LINES, PILOT_LINE, COMPLIANCE_TEXT, CONSULTING_TEXT } from "@/config/pricingText";

const card = "h-full bg-white border border-line rounded-[14px] p-8 shadow-[0_2px_10px_rgba(23,71,95,0.05)]";

export default function UniversalPricing() {
  return (
    <div>
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-steel mb-8" data-testid="pricing-intro">
          {PRICING_LEAD}
        </p>
      </Reveal>
      <div className="grid md:grid-cols-3 gap-5 mb-5">
        {TIER_LINES.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.1} className="h-full">
            <div data-testid={`pricing-tier-${t.name.toLowerCase()}`} className={card}>
              <h3 className="text-2xl font-extrabold text-navy mb-4">{t.name}</h3>
              <p className="text-sm text-ink leading-relaxed">{t.line}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.15}>
        <div data-testid="pricing-pilot" className="bg-hi rounded-[14px] p-8 mb-5">
          <h3 className="text-xl font-extrabold text-navydeep mb-1">Founding paid pilot</h3>
          <p className="text-sm font-semibold text-navydeep">{PILOT_LINE}</p>
        </div>
      </Reveal>
      <div className="grid md:grid-cols-2 gap-5">
        <Reveal delay={0.2} className="h-full">
          <div data-testid="pricing-compliance" className={card}>
            <h3 className="text-xl font-extrabold text-navy mb-4">Compliance Evaluation &amp; Documentation Service</h3>
            <p className="text-sm text-steel leading-relaxed">{COMPLIANCE_TEXT}</p>
          </div>
        </Reveal>
        <Reveal delay={0.25} className="h-full">
          <div data-testid="pricing-consulting" className={card}>
            <h3 className="text-xl font-extrabold text-navy mb-4">Consulting</h3>
            <p className="text-sm text-steel leading-relaxed">{CONSULTING_TEXT}</p>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
